import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import { Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import avataricon from '../../assests/avataricon.svg';
import { consentMapping } from '../../shared/constants';

function UpcomingConsentsCard(props) {
  const greenLableLocal = consentMapping[props.cardData.greenLabel];
  return (
    <div>
      <Card sx={{ width: '340px', height: '176px', borderRadius: ' 8px' }}>
        <CardContent>
          <Typography
            sx={{ fontSize: 16, fontWeight: 500, lineHeight: '24px' }}
            gutterBottom>
            {props.cardData.title}
          </Typography>

          <Grid container spacing={2}>
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Chip
                sx={{
                  mt: '4px',
                  maxWidth: '150px',
                  height: '16px',
                  background: ' #C2E7C9',
                  border: '1px solid #005F22',
                  boxSizing: ' border-box',
                  borderRadius: '24px',
                  textTransform: 'uppercase',
                  fontSize: 11,
                }}
                label={greenLableLocal}
              />
            </Grid>
            <Grid
              item
              sx={{
                maxWidth: '190px',
                display: 'flex',
                alignItems: 'center',
              }}>
              <Chip
                sx={{
                  mt: '4px',
                  height: '16px',
                  background: ' #FFE1AF',
                  border: '1px solid #FF9500',
                  boxSizing: ' border-box',
                  borderRadius: '24px',
                  textTransform: 'uppercase',
                  fontSize: 11,
                }}
                label={props.cardData.orangeLabel}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Avatar
                src={props.cardData.avatarLink || avataricon}
                sx={{ width: 16, height: 16 }}
              />
              <Typography
                sx={{
                  lineHeight: '16px',
                  fontSize: 12,
                  marginLeft: '8px',
                }}>
                {props.cardData.avatarName}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <SecondaryBtnComponent
            title={props.cardData.secondaryBtnTitle}
            fullWidth
            sx={{
              height: ' 40px',
              padding: ' 8px 24px',
              fontSize: '16px',
              m: '0px 13px',
            }}
          />
        </CardActions>
      </Card>
    </div>
  );
}

export default UpcomingConsentsCard;
